import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { groupBy, mapValues } from 'lodash';
import { Observable, map } from 'rxjs';

import { PortalConfig } from '@lockton-apps/client-gateway/interfaces';
import { PortalConfigDefinition } from '@lockton-apps/shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class PortalConfigService {
  constructor(
    @Inject('BASE_API_URL') private baseUrl: string,
    private http: HttpClient
  ) {}

  private _getConfigUrl() {
    return `${this.baseUrl}/configs`;
  }

  getConfig(locale: string): Observable<PortalConfigDefinition> {
    return this.http
      .get<PortalConfig[]>(this._getConfigUrl(), {
        params: { countryCode: locale },
      })
      .pipe(
        map((res) => {
          return mapValues(groupBy(res, 'id'), (arr) => ({ ...arr[0] }));
        })
      );
  }
}
